import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCampaignFilter } from '../hooks/useCampaignFilter';

import TilesTable from './components/TilesTable.jsx';
import QuestionTable from './components/QuestionTable';
import { Flex } from '@radix-ui/themes';

const QaReports = () => {
  const { t } = useTranslation('reports');
  const { campaignId } = useCampaignFilter();
  const [selectedTile, setSelectedTile] = useState(null);

  const handleTileClick = (tileId, tab) => {
    setSelectedTile({ uuid: tileId, tab });
  };

  const handleBack = () => {
    setSelectedTile(null);
  };

  if (selectedTile) {
    return (
      <QuestionTable
        questionTileId={selectedTile.uuid}
        selectedTab={selectedTile.tab}
        onBack={handleBack}
      />
    );
  }

  return (
    <Flex direction="column" gap="24px">
      <TilesTable
        campaignId={campaignId}
        dataType="live"
        tableTitle={t('qaTiles.liveTiles')}
        onTileClick={handleTileClick}
      />
      <TilesTable
        campaignId={campaignId}
        dataType="archived"
        tableTitle={t('qaTiles.archivedTiles')}
        onTileClick={handleTileClick}
      />
    </Flex>
  );
};

export default QaReports;
